export default __webpack_public_path__ + "cedb1d0134b14d7a03a686ba2c255ac0.svg";